import _ from 'lodash';

export function usePriceMapperV2() {
  const typeMap = {
    cmrPrice: 'cmr',
    normalPrice: 'normal',
    internetPrice: 'event',
  };

  const getCommonPriceProps = ({ price }) => {
    if (!price) return {};
    return {
      type: typeMap[price.type] || '',
      symbol: price.symbol || '',
      integerValue: price.price[0] || '0',
      crossed: price.crossed || false,
    };
  };

  const mapPricesV2 = (product) => {
    const cmrPrice = _.find(product.prices, { type: 'cmrPrice' });
    const eventPrice = _.find(product.prices, { type: 'eventPrice' });
    const basePrice = _.find(product.prices, { type: 'normalPrice' });
    const internetPricePrice = _.find(product.prices, { type: 'internetPrice' });

    let combination = '';
    if (cmrPrice) {
      combination = 'cmr';
    } else if (eventPrice) {
      combination = 'internet';
    }

    return {
      ...(basePrice && { base: getCommonPriceProps({ price: basePrice }) }),
      ...(internetPricePrice && { base: getCommonPriceProps({ price: internetPricePrice }) }),
      ...(eventPrice && {
        special: {
          ...getCommonPriceProps({ price: eventPrice }),
          ...(!cmrPrice && {
            discountValue: _.get(product, 'discountBadge.label', ''),
          }),
          bold: true,
        },
      }),
      ...(cmrPrice && {
        cmr: {
          ...getCommonPriceProps({ price: cmrPrice }),
          icon: 'cmr',
          discountValue: _.get(product, 'discountBadge.label', ''),
        },
      }),
      meta: { combination },
    };
  };

  return { mapPricesV2 };
}
